import translationsLoader from './translations-loader';

export default {
  translationsLoader,
};
